module.exports = __webpack_public_path__ + "src/assets/img/generating/da8fdab9dbbbb6f4ef8385b7b3fd8346.png";